export enum Delivery
{
  Sunday = 0,
  MonDelivery= 1,
  TuDelivery = 2,
  WedDelivery = 3,
  ThDelivery = 4,
  FriDelivery = 5,
  SatDelivery = 6
}